var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white"},[_c('div',{staticClass:"dashboard-container"},[_c('div',{staticClass:"dashboard-topbar d-flex align-items-center bg-white"},[_c('h2',{staticClass:"dashboard-topbar-title mb-0",domProps:{"textContent":_vm._s(_vm.title)}}),_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }